export default import.meta.ROLLDOWN_FILE_URL_Bnb8C5ntEGZj3RdS__VIbA